
export function useSlideTitle() {
  const title = `Price development - fertilizers`;
  return title;
}